// test1428
(1428 && 0);
